import axios from "axios";
import { ArrowRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import houseKeepingImage from "../../icons/houseKeeping.png";
import { baseUrl } from "../../Environments/environment";
import { Tick } from "../../icons/Tick";
import { toast, ToastContainer, Bounce } from "react-toastify";
import HouseKeepingRequestAddOn from "./HouseKeepingRequestAddOn";
import { isOutsideServiceHours } from "../../utils/housekeeping";
// const isOutsideServiceHours = (houseKeeping, settings) => {
// 	if (
// 		!houseKeeping?.serviceTimingEnabled ||
// 		!houseKeeping?.serviceTiming?.from ||
// 		!houseKeeping?.serviceTiming?.to
// 	) {
// 		return false; // no restriction
// 	}
//
// 	const match = settings?.timezone?.match(/UTC([+-]\d{2}:\d{2})/);
// 	const offset = match ? match[1] : "+00:00";
//
// 	const now = moment().utcOffset(offset);
// 	const currentTime = now.format("HH:mm");
//
// 	const from = houseKeeping.serviceTiming.from; // "09:00"
// 	const to = houseKeeping.serviceTiming.to; // "17:00"
//
// 	console.log(
// 		`Timezone Offset: ${offset}, Current Time: ${currentTime}, Service Hours: ${from} - ${to}`,
// 	);
//
// 	return currentTime < from || currentTime > to;
// };

const HouseKeepingService = () => {
	const guestid = useParams();
	const navigate = useNavigate();
	const guestSessionId = guestid.id;
	const [guest, setGuest] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [sentRequest, setSentRequest] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [houseKeeping, setHouseKeeping] = useState({
		name: "",
		description: "",
		disabled: false,
		options: [],
	});
	const [houseKeepingRequests, setHouseKeepingRequests] = useState([]);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [settings, setSettings] = useState(null);
	const fetchSettings = async () => {
		const response = await axios.get(
			`${baseUrl}/guestApi/${guestSessionId}/workflow`,
		);

		setSettings(response.data.result.settingFlow);
	};
	useEffect(() => {
		fetchSettings();
	}, []);

	const handleOptionChange = (e) => {
		if (e.target.checked) {
			setSelectedOptions([...selectedOptions, e.target.value]);
		} else {
			setSelectedOptions(
				selectedOptions.filter((option) => option !== e.target.value),
			);
		}
	};
	const getHouseKeepingRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
			);
			setHouseKeepingRequests(response.data.result);
		} catch (error) {
			console.error("Error getting House Keeping Requests:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await getHouseKeepingRequests();
		};
		fetchData();
	}, []);

	const handleNavigate = () => {
		navigate(`/${guestSessionId}/addOns`);
	};

	const getHouseKeeping = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/workflow`,
			);
			setHouseKeeping(response.data.result.addOnsFlow.houseKeepingAddOns);
			if (response.data.result.addOnsFlow.houseKeepingAddOns.disabled) {
				navigate(`/${guestSessionId}/addOns`);
			}
		} catch (error) {
			console.error("Error getting Housekeeping data:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await getHouseKeeping();
		};
		fetchData();
	}, []);

	const handleSendRequest = async () => {
		setIsLoading(true);
		try {
			if (houseKeeping.options.length !== 0 && selectedOptions.length === 0) {
				toast.error("Please select at least one option");
				setIsLoading(false);
				setSentRequest(false);
				return;
			}
			const data = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
				{
					name: houseKeeping.name,
					description: houseKeeping.description,
					options: selectedOptions,
				},
			);
			if (data.status === 200) {
				toast.success("Request sent successfully");
				setSentRequest(true);
			}
		} catch (e) {
			toast.error(e.response.data.message);
			console.log(e);
		} finally {
			setIsLoading(false);
		}
	};

	const handleGoHome = () => {
		navigate(`/${guestSessionId}`);
	};

	const getGuest = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/guest`,
			);
			setGuest(response.data.result);
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await getGuest();
		};

		fetchData();
	}, []);

	return (
		<div className="min-h-screen flex flex-col">
			{guest && (
				<>
					<div className="p-4 rounded-lg text-white w-full flex-shrink-0">
						<div className="flex flex-row justify-start items-center w-[100%]">
							<div className="text-[#FFFFFF] font-poppins text-left  text-sm w-full">
								<button className="w-[50%] text-black font-poppins text-center text-sm bg-white rounded-xl py-2">
									Service
								</button>
							</div>
							<div className="text-[#FFFFFF] font-poppins text-right text-sm w-full">
								<button
									onClick={handleGoHome}
									className="w-[50%] text-white font-poppins text-center text-sm bg-[#4F46E5] rounded-xl py-2 "
								>
									Home
								</button>
							</div>
						</div>

						<div className="bg-white rounded-xl shadow-lg overflow-hidden p-3 border border-gray-300 mt-6 mx-auto w-full ">
							<div className="text-[#B0B0B0] font-poppins text-left  text-[20px] ">
								Our Services
							</div>
							<img
								src={houseKeepingImage}
								alt="Housekeeping"
								className="w-full h-48 object-cover pt-4"
							/>
							<div className="mt-2">
								<h2 className="text-lg font-bold text-black">
									{houseKeeping.name}
								</h2>
								<p className="text-sm text-gray-600">
									{houseKeeping.description}
								</p>
								<button
									onClick={() => {
										if (!houseKeeping) return;

										if (isOutsideServiceHours(houseKeeping)) {
											toast.error(
												"You’re contacting a service outside business hours. Please reach out to the front desk.",
											);
											return;
										}

										setIsModalOpen(true);
									}}
									disabled={isLoading}
									className="w-full mt-1 py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
								>
									{isLoading ? (
										<>
											<svg
												className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
											>
												<circle
													className="opacity-25"
													cx="12"
													cy="12"
													r="10"
													stroke="currentColor"
													strokeWidth="4"
												/>
												<path
													className="opacity-75"
													fill="currentColor"
													d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
												/>
											</svg>
											Processing...
										</>
									) : sentRequest ? (
										<div className="flex items-center justify-center space-x-1">
											<Tick /> <div>Send New Request</div>
										</div>
									) : houseKeepingRequests.length === 0 ? (
										"Send Request"
									) : (
										"Send New Request"
									)}
								</button>
							</div>
						</div>
						<div
							className={`h-full mt-2 p-2 text-lg text-bold flex justify-center items-center cursor-pointer gap-2 }`}
							onClick={handleNavigate}
						>
							<p>View more services</p> <ArrowRight size={18} />
						</div>
						<ToastContainer
							position="top-right"
							autoClose={5000}
							hideProgressBar
							newestOnTop={false}
							closeOnClick
							rtl={false}
							pauseOnFocusLoss
							draggable
							pauseOnHover
							theme="light"
							transition={Bounce}
						/>
					</div>
					<div className="mt-auto text-center mb-6 text-gray-50 text-sm">
						Powered By Onelyk.Com
						<div className="mt-2 space-x-4">
							<a href="/terms" className="text-blue-400 hover:underline">
								Terms and Conditions
							</a>
							<a href="/privacy" className="text-blue-400 hover:underline">
								Privacy Policy
							</a>
						</div>
					</div>
				</>
			)}

			{/* Modal */}

			{isModalOpen && (
				<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
					{guest && (
						<HouseKeepingRequestAddOn
							houseKeeping={houseKeeping}
							isModalOpen={isModalOpen}
							setIsModalOpen={setIsModalOpen}
							handleSendRequest={handleSendRequest}
							handleOptionChange={handleOptionChange}
							selectedOptions={selectedOptions}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default HouseKeepingService;
